export function summarizeThread(threadText: string): string {
  const normalized = threadText.toLowerCase();

  const intents: { keywords: string[]; template: string }[] = [
    {
      keywords: ['slack', 'thread', 'prd', 'requirement', 'capture'],
      template: 'Build a Slack bot that captures informal thread discussions and turns them into structured PRD markdown files.',
    },
    {
      keywords: ['auth', 'login', 'oauth', 'password', 'pin'],
      template: 'Build an authentication service supporting PIN, password, OTP, and OAuth flows.',
    },
    {
      keywords: ['payment', 'transfer', 'checkout', 'cash-in', 'cash-out'],
      template: 'Build a payment feature that supports multiple channels and validates balances in real time.',
    },
    {
      keywords: ['notification', 'notify', 'email', 'push', 'sms'],
      template: 'Build a multi-channel notification system with user preferences and delivery tracking.',
    },
    {
      keywords: ['audit', 'log', 'trace'],
      template: 'Build an audit-trail service that captures and queries state-changing user actions.',
    },
    {
      keywords: ['offline', 'sync'],
      template: 'Build an offline-capable feature that queues local changes and syncs when connectivity returns.',
    },
  ];

  for (const intent of intents) {
    if (intent.keywords.some((kw) => normalized.includes(kw))) {
      return intent.template;
    }
  }

  return 'Build a feature based on the team discussion captured in this thread.';
}
